import { BaseStore } from 'fluxible/addons';
import Immutable from 'immutable';

const MAX_SELECTION = 3;

class BriefColorStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.selected = new Immutable.Set([]);
        this.customColors = null;
        this.colors = new Immutable.OrderedSet([]);
    }

    load(payload) {
        this.selected = new Immutable.Set(payload.body.colors);
        this.customColors = payload.body.custom_colors;

        if (payload.colors) {
            this.colors = new Immutable.OrderedSet(payload.colors);
        }

        this.emitChange();
    }

    updateColors(draft) {
        this.selected = new Immutable.Set(draft.body.colors);
        this.customColors = draft.body.custom_colors;
        this.emitChange();
    }

    updateCustomColors(payload) {
        this.customColors = payload.value;
        this.emitChange();
    }

    toggleColor(color) {
        if (!this.selected.has(color)) {
            this.selected = this.selected.add(color);
        } else {
            this.selected = this.selected.delete(color);
        }

        this.emitChange();
    }

    isMaxSelected() {
        return this.selected.count() >= MAX_SELECTION;
    }

    isStepComplete() {
        return this.selected.count() >= 1 ||
            (this.customColors && this.customColors.trim().length);
    }

    getState() {
        return {
            customColors: this.customColors,
            colors: this.colors,
            selected: this.selected,
            isMaxSelected: this.isMaxSelected(),
            isStepComplete: this.isStepComplete()
        };
    }
}

BriefColorStore.storeName = 'BriefColorStore';
BriefColorStore.handlers = {
    SAVE_DRAFT_SUCCESS: 'updateColors',
    UPDATE_CUSTOM_COLORS: 'updateCustomColors',
    TOGGLE_COLOR: 'toggleColor',
    LOAD_DRAFT_DATA: 'load'
};

export default BriefColorStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefColorStore.js